<template>
  <b-row class="filter2 filter-menu">
    <b-col cols="6" class="filter-all border-r border-passive" id="rubriken">
      <a class="filter-links link-rubriken normallink" :class="{'text-red':filter.categories.length}" href="#" @click="showHideRubriken()">Alle Rubriken <span
          v-if="filter.categories.length" @click.stop="clearFilter('categories')"><svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 19.4 19.4; fill: currentColor; width: 1.4rem; height: 1.4rem;" version="1.1" viewBox="0 0 19.4 19.4" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon
          points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg></span>
        <svg class="dropdown-icon" height="17px" id="dropdown-icon-rubriken"
             style="enable-background:new 0 0 31.4 16.6;" version="1.1" viewbox="0 0 31.4 16.6" width="32px" x="0px"
             xml:space="preserve" y="0px"><title>dropdown</title>
          <g id="Symbols"><g transform="translate(1.000000, -7.000000)"><polygon points="14.7,23.6 -1,8.4 0.4,7 14.7,20.8 29,7 30.4,8.4"/></g></g></svg>
      </a>
    </b-col>
    <b-col cols="3" class="filter-all border-r border-passive" id="autoren">
      <a class="filter-links link-autoren normallink" :class="{'text-red':filter.authors.length}" href="#" @click="showHideAutor()">Autor_innen <span
          v-if="filter.authors.length" @click.stop="clearFilter('authors')"><svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 19.4 19.4; fill: currentColor; width: 1.4rem; height: 1.4rem;" version="1.1" viewBox="0 0 19.4 19.4" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon
          points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg></span>
        <svg class="dropdown-icon" height="17px" id="dropdown-icon-autoren" style="enable-background:new 0 0 31.4 16.6;"
             version="1.1" viewbox="0 0 31.4 16.6" width="32px" x="0px" xml:space="preserve" y="0px"><title>dropdown</title>
          <g id="Symbols"><g transform="translate(1.000000, -7.000000)"><polygon points="14.7,23.6 -1,8.4 0.4,7 14.7,20.8 29,7 30.4,8.4"/></g></g></svg>
      </a>
    </b-col>
    <b-col cols="3" class="filter-all border-passive" id="ausgabe">
      <a class="filter-links link-ausgabe normallink" :class="{'text-red':filter.issues .length}" href="#" @click="showHideAusgabe()">Ausgabe <span
          v-if="filter.issues.length" @click.stop="clearFilter('issues')"><svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 19.4 19.4; fill: currentColor; width: 1.4rem; height: 1.4rem;" version="1.1" viewBox="0 0 19.4 19.4" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon
          points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg></span>
        <svg class="dropdown-icon" height="17px" id="dropdown-icon-ausgabe" style="enable-background:new 0 0 31.4 16.6;"
             version="1.1" viewbox="0 0 31.4 16.6" width="32px" x="0px" xml:space="preserve" y="0px"><title>dropdown</title>
          <g id="Symbols"><g transform="translate(1.000000, -7.000000)"><polygon points="14.7,23.6 -1,8.4 0.4,7 14.7,20.8 29,7 30.4,8.4"/></g></g></svg>
      </a>
    </b-col>
  </b-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

const axios = require("axios");

export default {
  name: "filterRowTwo",
  components: {
    //Navigation
  },
  props: {
    DropdownOpen: Array
  },
  data() {
    return {
      // entries: [],
      //MenuIsOpen: false
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      // data: {
      //   query: `
      //         query {
      //            entries() {

      //           }
      //         }
      //       `,
      // },
    })
    // .then((result) => {
    //   let data = result.data.data.entries;
    //   console.log(data);

    //   // assign the fetched data 2 times, once for manipulation
    //   // once for reseting
    //   this.entries = data;
    //   this.entriesToManipulate = data;
    // });
  },
  computed: {
    ...mapGetters(['filter'])
  },
  methods: {
    ...mapActions(['clearFilter']),
    showHideAutor() {
      document.getElementById("autorDropdown").classList.toggle("show");
      if (document.getElementById("ausgabeDropdown").classList.contains("show")) {
        document.getElementById("ausgabeDropdown").classList.remove("show")
      }
      if (document.getElementById("schlagworteDropdown").classList.contains("show")) {
        document.getElementById("schlagworteDropdown").classList.remove("show")
      }
      if (document.getElementById("rubrikenDropdown").classList.contains("show")) {
        document.getElementById("rubrikenDropdown").classList.remove("show")
      }
      document.getElementById("autoren").classList.toggle("border-active");
      if (document.getElementById("rubriken").classList.contains("border-active")) {
        document.getElementById("rubriken").classList.remove("border-active")
      }
      if (document.getElementById("schlagworte").classList.contains("border-active")) {
        document.getElementById("schlagworte").classList.remove("border-active")
      }
      if (document.getElementById("ausgabe").classList.contains("border-active")) {
        document.getElementById("ausgabe").classList.remove("border-active")
      }
      document.getElementById("dropdown-icon-autoren").classList.toggle("flip-dropdown");
      if (document.getElementById("dropdown-icon-ausgabe").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-ausgabe").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-schlagworte").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-schlagworte").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-rubriken").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-rubriken").classList.remove("flip-dropdown")
      }
    },
    showHideAusgabe() {
      document.getElementById("ausgabeDropdown").classList.toggle("show");
      if (document.getElementById("autorDropdown").classList.contains("show")) {
        document.getElementById("autorDropdown").classList.remove("show")
      }
      if (document.getElementById("schlagworteDropdown").classList.contains("show")) {
        document.getElementById("schlagworteDropdown").classList.remove("show")
      }
      if (document.getElementById("rubrikenDropdown").classList.contains("show")) {
        document.getElementById("rubrikenDropdown").classList.remove("show")
      }
      document.getElementById("ausgabe").classList.toggle("border-active");
      if (document.getElementById("rubriken").classList.contains("border-active")) {
        document.getElementById("rubriken").classList.remove("border-active")
      }
      if (document.getElementById("autoren").classList.contains("border-active")) {
        document.getElementById("autoren").classList.remove("border-active")
      }
      if (document.getElementById("schlagworte").classList.contains("border-active")) {
        document.getElementById("schlagworte").classList.remove("border-active")
      }
      document.getElementById("dropdown-icon-ausgabe").classList.toggle("flip-dropdown");
      if (document.getElementById("dropdown-icon-rubriken").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-rubriken").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-autoren").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-autoren").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-schlagworte").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-schlagworte").classList.remove("flip-dropdown")
      }
    },
    showHideRubriken() {
      document.getElementById("rubrikenDropdown").classList.toggle("show");
      if (document.getElementById("autorDropdown").classList.contains("show")) {
        document.getElementById("autorDropdown").classList.remove("show")
      }
      if (document.getElementById("ausgabeDropdown").classList.contains("show")) {
        document.getElementById("ausgabeDropdown").classList.remove("show")
      }
      if (document.getElementById("schlagworteDropdown").classList.contains("show")) {
        document.getElementById("schlagworteDropdown").classList.remove("show")
      }
      document.getElementById("rubriken").classList.toggle("border-active");
      if (document.getElementById("schlagworte").classList.contains("border-active")) {
        document.getElementById("schlagworte").classList.remove("border-active")
      }
      if (document.getElementById("autoren").classList.contains("border-active")) {
        document.getElementById("autoren").classList.remove("border-active")
      }
      if (document.getElementById("ausgabe").classList.contains("border-active")) {
        document.getElementById("ausgabe").classList.remove("border-active")
      }
      document.getElementById("dropdown-icon-rubriken").classList.toggle("flip-dropdown");
      if (document.getElementById("dropdown-icon-ausgabe").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-ausgabe").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-autoren").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-autoren").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-schlagworte").classList.contains("flip-dropdown")) {
        document.getElementById("dropdown-icon-schlagworte").classList.remove("flip-dropdown")
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
</style>